import type { MetricDefinition, MetricValue } from '@/api/types'

/**
 * 指标定义 + 指标值数据
 * 4个维度: 招生(ENROLLMENT) / 教学(TEACHING) / 课消(CONSUMPTION) / 财务(FINANCE)
 * 每维度3-5个指标，每指标含6个月时间序列
 */

// ===== 指标定义 =====

export const mockMetricDefinitions: MetricDefinition[] = [
  // 招生维度
  {
    id: 'md-enroll-001',
    code: 'NEW_LEADS',
    name: '新增线索数',
    dimension: 'ENROLLMENT',
    unit: '人',
    description: '当月新增线索总量',
    createdAt: '2025-01-01T00:00:00Z',
    updatedAt: '2025-01-01T00:00:00Z',
    createdBy: 'system',
    updatedBy: 'system',
  },
  {
    id: 'md-enroll-002',
    code: 'CONVERSION_RATE',
    name: '线索转化率',
    dimension: 'ENROLLMENT',
    unit: '%',
    description: '线索转为学员的比例',
    createdAt: '2025-01-01T00:00:00Z',
    updatedAt: '2025-01-01T00:00:00Z',
    createdBy: 'system',
    updatedBy: 'system',
  },
  {
    id: 'md-enroll-003',
    code: 'NEW_STUDENTS',
    name: '新增学员数',
    dimension: 'ENROLLMENT',
    unit: '人',
    description: '当月新增签约学员',
    createdAt: '2025-01-01T00:00:00Z',
    updatedAt: '2025-01-01T00:00:00Z',
    createdBy: 'system',
    updatedBy: 'system',
  },
  {
    id: 'md-enroll-004',
    code: 'ENROLLMENT_REVENUE',
    name: '签约金额',
    dimension: 'ENROLLMENT',
    unit: '元',
    description: '当月签约合同总金额',
    createdAt: '2025-01-01T00:00:00Z',
    updatedAt: '2025-01-01T00:00:00Z',
    createdBy: 'system',
    updatedBy: 'system',
  },

  // 教学维度
  {
    id: 'md-teach-001',
    code: 'SESSION_COUNT',
    name: '授课场次',
    dimension: 'TEACHING',
    unit: '场',
    description: '当月已完成授课场次',
    createdAt: '2025-01-01T00:00:00Z',
    updatedAt: '2025-01-01T00:00:00Z',
    createdBy: 'system',
    updatedBy: 'system',
  },
  {
    id: 'md-teach-002',
    code: 'ATTENDANCE_RATE',
    name: '出勤率',
    dimension: 'TEACHING',
    unit: '%',
    description: '实际出勤占总预约的比例',
    createdAt: '2025-01-01T00:00:00Z',
    updatedAt: '2025-01-01T00:00:00Z',
    createdBy: 'system',
    updatedBy: 'system',
  },
  {
    id: 'md-teach-003',
    code: 'STUDENT_SATISFACTION',
    name: '学员满意度',
    dimension: 'TEACHING',
    unit: '分',
    description: '学员课后评分平均分(满分5)',
    createdAt: '2025-01-01T00:00:00Z',
    updatedAt: '2025-01-01T00:00:00Z',
    createdBy: 'system',
    updatedBy: 'system',
  },

  // 课消维度
  {
    id: 'md-cons-001',
    code: 'CONSUMED_SESSIONS',
    name: '课消场次',
    dimension: 'CONSUMPTION',
    unit: '场',
    description: '当月实际消耗课时数',
    createdAt: '2025-01-01T00:00:00Z',
    updatedAt: '2025-01-01T00:00:00Z',
    createdBy: 'system',
    updatedBy: 'system',
  },
  {
    id: 'md-cons-002',
    code: 'CONSUMPTION_REVENUE',
    name: '课消收入',
    dimension: 'CONSUMPTION',
    unit: '元',
    description: '当月课消确认收入',
    createdAt: '2025-01-01T00:00:00Z',
    updatedAt: '2025-01-01T00:00:00Z',
    createdBy: 'system',
    updatedBy: 'system',
  },
  {
    id: 'md-cons-003',
    code: 'REMAINING_BALANCE',
    name: '剩余权益余额',
    dimension: 'CONSUMPTION',
    unit: '元',
    description: '未消耗权益卡总余额',
    createdAt: '2025-01-01T00:00:00Z',
    updatedAt: '2025-01-01T00:00:00Z',
    createdBy: 'system',
    updatedBy: 'system',
  },

  // 财务维度
  {
    id: 'md-fin-001',
    code: 'REVENUE_TOTAL',
    name: '总收入',
    dimension: 'FINANCE',
    unit: '元',
    description: '当月各项收入合计',
    createdAt: '2025-01-01T00:00:00Z',
    updatedAt: '2025-01-01T00:00:00Z',
    createdBy: 'system',
    updatedBy: 'system',
  },
  {
    id: 'md-fin-002',
    code: 'REFUND_AMOUNT',
    name: '退款金额',
    dimension: 'FINANCE',
    unit: '元',
    description: '当月退款总额',
    createdAt: '2025-01-01T00:00:00Z',
    updatedAt: '2025-01-01T00:00:00Z',
    createdBy: 'system',
    updatedBy: 'system',
  },
  {
    id: 'md-fin-003',
    code: 'AR_BALANCE',
    name: '应收余额',
    dimension: 'FINANCE',
    unit: '元',
    description: '未结算账单总金额',
    createdAt: '2025-01-01T00:00:00Z',
    updatedAt: '2025-01-01T00:00:00Z',
    createdBy: 'system',
    updatedBy: 'system',
  },
]

// ===== 指标值（6个月时间序列，覆盖3个校区） =====

const periods = ['2025-01', '2025-02', '2025-03', '2025-04', '2025-05', '2025-06']
const campuses = ['c-001', 'c-002', 'c-003']

function genValues(
  metricCode: string,
  base: number,
  variance: number,
  trend: number,
): MetricValue[] {
  const result: MetricValue[] = []
  let seq = 0
  for (const period of periods) {
    for (const campusId of campuses) {
      const trendOffset = trend * seq
      const noise = Math.sin(seq * 1.7 + metricCode.charCodeAt(0)) * variance
      result.push({
        id: `mv-${metricCode}-${period}-${campusId}`,
        metricCode,
        campusId,
        period,
        value: Math.round((base + trendOffset + noise) * 100) / 100,
        createdAt: '2025-01-01T00:00:00Z',
        updatedAt: '2025-01-01T00:00:00Z',
        createdBy: 'system',
        updatedBy: 'system',
      })
      seq++
    }
  }
  return result
}

export const mockMetricValues: MetricValue[] = [
  // 招生
  ...genValues('NEW_LEADS', 120, 20, 5),
  ...genValues('CONVERSION_RATE', 35, 5, 1.5),
  ...genValues('NEW_STUDENTS', 45, 8, 2),
  ...genValues('ENROLLMENT_REVENUE', 580000, 80000, 30000),
  // 教学
  ...genValues('SESSION_COUNT', 320, 40, 10),
  ...genValues('ATTENDANCE_RATE', 88, 4, 0.5),
  ...genValues('STUDENT_SATISFACTION', 4.5, 0.15, 0.02),
  // 课消
  ...genValues('CONSUMED_SESSIONS', 280, 35, 12),
  ...genValues('CONSUMPTION_REVENUE', 420000, 60000, 20000),
  ...genValues('REMAINING_BALANCE', 1850000, 100000, 50000),
  // 财务
  ...genValues('REVENUE_TOTAL', 480000, 70000, 25000),
  ...genValues('REFUND_AMOUNT', 15000, 5000, -800),
  ...genValues('AR_BALANCE', 95000, 15000, -3000),
]


// ===== 扩展数据：招生漏斗 =====
export const mockEnrollmentFunnel = {
  stages: ['新增线索', '到访体验', '试听完成', '意向签约', '正式签约'],
  values: [480, 280, 220, 160, 125],
}

// ===== 扩展数据：线索来源分布 =====
export const mockLeadSourceDist = {
  labels: ['转介绍', '线上推广', '到店咨询', '活动引流', '其他'],
  values: [185, 120, 95, 55, 25],
}

// ===== 扩展数据：教学雷达（5维度） =====
export const mockTeachingRadar = {
  labels: ['出勤率', '满班率', '满意度', '续费率', '试听转化'],
  series: [
    { name: '本月', values: [88, 75, 4.5, 72, 65] },
    { name: '上月', values: [82, 70, 4.3, 68, 58] },
  ],
}

// ===== 扩展数据：课消对比（按校区） =====
export const mockConsumptionByCampus = {
  labels: ['高新校区', '锦江校区', '双流校区'],
  values: [980, 820, 650],
}

// ===== 扩展数据：财务收入构成 =====
export const mockRevenueComposition = {
  labels: ['会员卡收入', '课程收入', '商品收入', '其他收入'],
  values: [680000, 320000, 85000, 35000],
}

// ===== 扩展数据：收支趋势（折线+柱状组合） =====
export const mockRevenueExpenseTrend = {
  periods: ['1月', '2月', '3月', '4月', '5月', '6月'],
  revenue: [420000, 380000, 510000, 480000, 560000, 620000],
  expense: [280000, 250000, 320000, 300000, 350000, 380000],
}

// ===== 扩展数据：课消月度趋势 =====
export const mockConsumptionMonthly = {
  periods: ['1月', '2月', '3月', '4月', '5月', '6月'],
  sessions: [240, 220, 280, 260, 300, 320],
  revenue: [360000, 330000, 420000, 390000, 450000, 480000],
}

// ===== 扩展数据：招生月度趋势（多指标对比） =====
export const mockEnrollmentMonthly = {
  periods: ['1月', '2月', '3月', '4月', '5月', '6月'],
  leads: [100, 120, 115, 130, 135, 155],
  students: [38, 42, 40, 48, 52, 55],
}

// ===== 扩展数据：校区对比（多维度） =====
export const mockCampusComparison = {
  labels: ['高新校区', '锦江校区', '双流校区'],
  revenue: [680000, 520000, 380000],
  students: [180, 140, 110],
  sessions: [320, 280, 220],
}

// ===== 扩展数据：合同到期分布 =====
export const mockContractExpiry = {
  labels: ['已到期', '1月内', '1-3月', '3-6月', '6月以上'],
  values: [12, 25, 48, 85, 156],
}

// ===== 扩展数据：员工绩效排行 =====
export const mockStaffPerformance = {
  labels: ['张老师', '李顾问', '王老师', '赵顾问', '陈老师', '刘前台'],
  values: [92000, 85000, 78000, 72000, 65000, 45000],
}

// ===== 扩展数据：综合KPI =====
export const mockAnalyticsKPI = [
  { key: 'total_revenue', label: '总营收', value: 2970000, unit: '元', change: 15.2, icon: 'Money' },
  { key: 'new_students', label: '新增学员', value: 275, unit: '人', change: 12.5, icon: 'User' },
  { key: 'attendance_rate', label: '出勤率', value: 88.5, unit: '%', change: 3.2, icon: 'CircleCheck' },
  { key: 'consumption', label: '课消金额', value: 2430000, unit: '元', change: 8.8, icon: 'TrendCharts' },
  { key: 'conversion_rate', label: '转化率', value: 26.0, unit: '%', change: -2.1, icon: 'Promotion' },
  { key: 'satisfaction', label: '满意度', value: 4.5, unit: '分', change: 1.8, icon: 'Star' },
]


// ===== 从业务模块聚合的分析数据 =====
import { mockLeads } from './leads'
import { mockContractFlows } from './contracts'
import { mockEntitlementCards, mockEntitlementAccounts } from './entitlements'
import { mockBookings } from './bookings'
import { mockInventoryItems } from './inventory'
import { mockStaffs } from './staffs'
import { mockClasses } from './classes'
import { mockCourses } from './courses'
import { mockApprovals } from './approvals'
import { mockFamilyGroups } from './familyGroups'

// 线索状态分布（从 leads 聚合）
export const mockLeadStatusDist = (() => {
  const map: Record<string, number> = {}
  mockLeads.forEach(l => { map[l.status] = (map[l.status] || 0) + 1 })
  const labels: Record<string, string> = {
    NEW: '新线索', ASSIGNED: '已分配', FOLLOWING: '跟进中',
    MEMBER: '已签约', CONVERTED: '已转化', RECYCLED: '回收', NORMAL: '普通', EXPIRED: '已过期', CHURNED: '已流失',
  }
  return {
    labels: Object.keys(map).map(k => labels[k] || k),
    values: Object.values(map),
  }
})()

// 合同类型分布（从 contracts 聚合）
export const mockContractTypeDist = (() => {
  const map: Record<string, number> = {}
  mockContractFlows.forEach(c => {
    if (c.flowType) map[c.flowType] = (map[c.flowType] || 0) + 1
  })
  const labels: Record<string, string> = {
    ENROLLMENT: '报名合同', MEMBERSHIP: '会员卡合同', COURSE: '课程合同', REFUND: '退款合同',
  }
  return {
    labels: Object.keys(map).map(k => labels[k] || k),
    values: Object.values(map),
  }
})()

// 合同状态分布
export const mockContractStatusDist = (() => {
  const map: Record<string, number> = {}
  mockContractFlows.forEach(c => {
    const s = c.status || 'UNKNOWN'
    map[s] = (map[s] || 0) + 1
  })
  const labels: Record<string, string> = {
    DRAFT: '草稿', PENDING_SIGN: '待签', ACTIVE: '生效中', EXPIRED: '已到期', TERMINATED: '已终止', WITHDRAWN: '已撤回',
  }
  return {
    labels: Object.keys(map).map(k => labels[k] || k),
    values: Object.values(map),
  }
})()

// 会员卡类型分布（从 entitlements 聚合）
export const mockEntitlementTypeDist = (() => {
  const map: Record<string, number> = {}
  mockEntitlementCards.forEach(e => {
    const t = e.templateId?.includes('time') ? 'TIME_CARD' : e.templateId?.includes('stored') ? 'STORED_VALUE' : 'COUNT_CARD'
    map[t] = (map[t] || 0) + 1
  })
  const labels: Record<string, string> = {
    COUNT_CARD: '次卡', STORED_VALUE: '储值卡', TIME_CARD: '期限卡',
  }
  return {
    labels: Object.keys(map).map(k => labels[k] || k),
    values: Object.values(map),
  }
})()

// 会员卡状态分布
export const mockEntitlementStatusDist = (() => {
  const map: Record<string, number> = {}
  mockEntitlementCards.forEach(e => {
    const s = e.status || 'UNKNOWN'
    map[s] = (map[s] || 0) + 1
  })
  const labels: Record<string, string> = {
    ACTIVE: '正常', FROZEN: '冻结', EXPIRED: '已过期', REFUNDED: '已退卡', CONSUMED: '已用完',
  }
  return {
    labels: Object.keys(map).map(k => labels[k] || k),
    values: Object.values(map),
  }
})()

// 预约状态分布（从 bookings 聚合）
export const mockBookingStatusDist = (() => {
  const map: Record<string, number> = {}
  mockBookings.forEach(b => {
    const s = b.status || 'UNKNOWN'
    map[s] = (map[s] || 0) + 1
  })
  const labels: Record<string, string> = {
    PENDING: '待处理', CHECKED_IN: '已签到', CANCELLED: '已取消', EXPIRED: '已过期', NOSHOW: '未到课', QUEUED: '排队中',
  }
  return {
    labels: Object.keys(map).map(k => labels[k] || k),
    values: Object.values(map),
  }
})()

// 库存分类分布（从 inventory 聚合）
export const mockInventoryCategoryDist = (() => {
  const map: Record<string, number> = {}
  const qtyMap: Record<string, number> = {}
  mockInventoryItems.forEach(item => {
    const cat = item.category || '其他'
    map[cat] = (map[cat] || 0) + 1
    qtyMap[cat] = (qtyMap[cat] || 0) + (item.quantity || 0)
  })
  return {
    labels: Object.keys(map),
    values: Object.values(qtyMap),
  }
})()

// 员工角色分布（从 staffs 聚合）
export const mockStaffRoleDist = (() => {
  const map: Record<string, number> = {}
  mockStaffs.forEach(s => {
    const r = s.roleName || s.roleId || '未知'
    map[r] = (map[r] || 0) + 1
  })
  return {
    labels: Object.keys(map),
    values: Object.values(map),
  }
})()

// 员工状态分布
export const mockStaffStatusDist = (() => {
  const map: Record<string, number> = {}
  mockStaffs.forEach(s => {
    const st = s.status || 'UNKNOWN'
    map[st] = (map[st] || 0) + 1
  })
  const labels: Record<string, string> = {
    PENDING_ACTIVATION: '待激活', ACTIVE: '在职', DISABLED: '已停用',
  }
  return {
    labels: Object.keys(map).map(k => labels[k] || k),
    values: Object.values(map),
  }
})()

// 审批类型分布（从 approvals 聚合）
export const mockApprovalTypeDist = (() => {
  const map: Record<string, number> = {}
  mockApprovals.forEach(a => {
    const t = a.type || 'UNKNOWN'
    map[t] = (map[t] || 0) + 1
  })
  const labels: Record<string, string> = {
    CONTRACT_SIGN: '合同签署', CONTRACT_TRANSFER: '合同转校', CONTRACT_TERMINATE: '合同终止',
    COURSE_CHECKIN: '课程签到', COURSE_LEAVE: '课程请假', COURSE_ABSENT: '课程旷课', COURSE_MAKEUP: '课程补签',
    MEMBERSHIP_ISSUE: '会员卡办卡', MEMBERSHIP_REFUND: '会员卡退卡', MEMBERSHIP_FREEZE: '会员卡冻结', MEMBERSHIP_UNFREEZE: '会员卡解冻',
    FINANCE_REFUND: '财务退费', FINANCE_DISCOUNT: '财务折扣', FINANCE_EXPENSE: '财务报销',
  }
  return {
    labels: Object.keys(map).map(k => labels[k] || k),
    values: Object.values(map),
  }
})()

// 审批状态分布
export const mockApprovalStatusDist = (() => {
  const map: Record<string, number> = {}
  mockApprovals.forEach(a => {
    const s = a.status || 'UNKNOWN'
    map[s] = (map[s] || 0) + 1
  })
  const labels: Record<string, string> = {
    PENDING: '待审批', APPROVED: '已通过', REJECTED: '已拒绝', WITHDRAWN: '已撤回',
  }
  return {
    labels: Object.keys(map).map(k => labels[k] || k),
    values: Object.values(map),
  }
})()

// 班级人数分布（从 classes 聚合）
export const mockClassSizeDist = (() => {
  return {
    labels: mockClasses.map(c => c.name || c.id),
    values: mockClasses.map(c => (c as any).enrolledCount || (c as any).studentCount || Math.floor(Math.random() * 20) + 5),
  }
})()

// 课程热度排行（从 courses 聚合）
export const mockCoursePopularity = (() => {
  return {
    labels: mockCourses.map(c => c.name || c.id),
    values: mockCourses.map(() => Math.floor(Math.random() * 80) + 20),
  }
})()

// 家庭组规模分布
export const mockFamilyGroupSize = (() => {
  return {
    labels: mockFamilyGroups.map(g => g.name || g.id),
    values: mockFamilyGroups.map(g => g.memberCount || 1),
  }
})()
